import { Box, Button, CircularProgress, Fade, Modal, TextField, Typography } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";
import { useState,useRef,useEffect } from "react";
import { useTheme } from '@mui/material/styles';
import { Panel, PanelGroup } from "rsuite";
import { Helmet } from 'react-helmet';
import { Drawer} from 'rsuite';
import { Editor } from "react-draft-wysiwyg";
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import { EditorState, convertToRaw } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import boldSvg from "../Images/text-bold.svg";
import 'froala-editor/css/froala_style.min.css';
import 'froala-editor/css/froala_editor.pkgd.min.css';
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/js/plugins/image.min.js";
import "froala-editor/js/plugins/save.min.js";
import "froala-editor/js/plugins/font_family.min.js";
import "froala-editor/js/plugins/font_size.min.js";
import "froala-editor/js/plugins/entities.min.js";
import "froala-editor/js/plugins/code_view.min.js";
import axios from "axios";
import BaseUrl from "../BaseUrl";
import { useHistory } from "react-router-dom";
import Tooltip from '@mui/material/Tooltip';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import RichTextEditor from 'react-rte';

import DrawerClass from "./DrawerClass";
const editorData = [
  {
    id: 1,
    title: "Template",
    accordionServices: [
      {
        id: 1,
        text: "Sales",
      },
      {
        id: 2,
        text: "Marketing",
      },
    ],
  },
  {
    id: 2,
    title: "Email AI",
    accordionServices: [
      {
        id: 1,
        text: "Campaign Sales",
      },
      {
        id: 2,
        text: "Campaign Marketing",
      },
    ],
  },
  {
    id: 3,
    title: "Variable",
    accordionServices: [
      {
        id: 1,
        text: "Email",
      },
      {
        id: 2,
        text: "First Name",
      },
      {
        id: 3,
        text: "Last Name",
      },
      {
        id: 4,
        text: "Phone Number",
      },
      {
        id: 5,
        text: "Company Name",
      },
      {
        id: 6,
        text: "Website",
      },
    ],
  },
  {
    id:4,
    type:"no",
    text:"Source code"
  },
  {
    id:5,
    type:"no",
    text:"Unsubscribe link"
  },
  {
    id:6,
    type:"no",
    text:"Calendly link"
  }
];

// const data = [
//     {
//         id:1,
//         title: "Product pitch 1 (B2B & B2C) - AIDA formula",
//         type:"general",
//     },
//     {
//         id:2,
//         title: "Product pitch 2 (B2B & B2C) - AIDA formula",
//         type:"general",
//     },
//     {
//         id:3,
//         title: "Product pitch 3 (B2B & B2C) - BBB formula",
//         type:"general",
//     },
//     {
//         id:4,
//         title: "Product pitch 7 (B2B)",
//         type:"general",
//     },
// ]

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: '60vw',
    bgcolor: "background.paper",
    border: "2px solid transparent",
    borderRadius: "7px",
    boxShadow: 24,
    p: 2,
};

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const names = [
  'Oliver Hansen',
  'Van Henry',
  'April Tucker',
  'Ralph Hubbard',
];

const TemplatesComponent = () => {
  const userDetails = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
  const [openModal, setOpenModal] = useState(false);
  const [templateEmail, setTemplateEmail] = useState('');
  const [modalTitle, setModalTitle] = useState("");
  const [openDrawer, setOpenDrawer] = useState(false);
  const [tempAdmin, setTempAdmin] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const [data, setData] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [editorState, setEditorState] = useState(EditorState.createEmpty());
  const [editorContent, setEditorContent] = useState('');
  const [selectedTemplateArray,setSelectedTemplateArray]=useState([])
  const [templateData,setTemplateData]=useState([
    {
      id: 1,
      title: "All Email Templates",
      accordion:[
         {
          accordionTitle: "Coldemail Template",
          accordionServices: [
            
          ],
         },
         {
          accordionTitle: "My templates",
          accordionServices: [
          ],
         }
      ]
     
    },
    {
      id: 2,
      title: "All Campaign Templates",
      accordion:[{
        accordionTitle: "Campaign Templates",
        accordionServices: [
        ],
      }]
     
    },
  ])
  const [open, setOpen] = useState(false);
  const [selectedVar,setSelectedVar] = useState('');
  const [fallBackText,setFallBackText] = useState('');
  const theme = useTheme();
  const [personName, setPersonName] = useState("");
  const [templateName, setTemplateName] = useState("");
  const [selectedFolder, setSelectedFolder] = useState("");
  const [folderName, setFolderName] = useState("");
  const [allUserTemplate, setAllUserTemplate] = useState([]);
  const editorRef = useRef(null);
  const textFieldRef = useRef(null);
  const history = useHistory();
  const [toggleDiv,setToggleDiv] = useState(false);
  const [openDeleteModal,setOpenDeleteModal] = useState(false);
  const [openDeleteFolderModal,setOpenDeleteFolderModal] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [selectedTemplateId, setSelectedTemplateId] = useState("");
  const [editFolderName, setEditFolderName] = useState(true);
  const [editableDataObj, setEditableDataObj] = useState(null);
  const [showLoader,setShowLoader] = useState(true);
  const [model, setModel] = useState(()=>{
    return editableDataObj === null ? "" : editableDataObj.SubTemplate
  });

  const [editorValue, setEditorValue] = useState(RichTextEditor.createEmptyValue());

  const handleSave = () => {
    const content = editorValue.toString('html');
    console.log('Content:', content);
  };
  
  const insertHTMLAtCursor = (text) => {
    if (editorRef.current) {
      const editor = editorRef.current.editor;
      
      // Get the current cursor position
      const cursorPosition = editor.selection.get();
     
      // Your HTML content to insert
      const newHTML = `&nbsp<span class="clickable-span" style='display: inline;
      padding: 4px 14px;
      width:auto;
      justify-content: center;
      align-items: center;
      gap: 10px;border-radius: 4px;
      border: 1px solid var(--color-primary, #1C485F);
      color: var(--color-primary, #1C485F);
      text-align: center;
      font-family: Source Sans Pro;
      white-space: nowrap;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
      cursor:pointer;
' contenteditable="false">${text}</span>&nbsp`;

      // Insert the HTML content at the cursor position
       console.log("cursorpoaituonm index",cursorPosition.anchorOffset)
      editor.html.insert(newHTML, cursorPosition.anchorOffset);
      const editorContainer = editor.el;
      const clickableClass = 'clickable-span';
  
      const handleClick = (event) => {
        const clickedElement = event.target;
        if (clickedElement.classList.contains(clickableClass)) {
          // Handle the click
          const clickedText = clickedElement.textContent;
          console.log('Clicked on:', clickedText);
         
          setOpen(true)
          
          setSelectedVar(clickedText)
          // Update the model if needed
          setModel(editor.html.get());
        }
      };
  
      editorContainer.removeEventListener('click', handleClick); // Remove the previous event listener
      editorContainer.addEventListener('click', handleClick);
  
      // Update the model if needed
      setModel(editor.html.get());
    }
  };
 const getAllTemplate = () => {
  setShowLoader(true);
    const userDetailssss = JSON.parse(localStorage.getItem("MailSenderuserDetails"));
    axios
      .get(
        `${
          BaseUrl.baseurl
        }/email-marketing/user-template/get-admin-user-template/${
          userDetailssss && userDetailssss.details._id
        }`,
        {
          headers: {
            Authorization: `Bearear ${userDetailssss && userDetailssss.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          console.log("fkfkfkfk",response.data)
           templateData[0].accordion[0].accordionServices=response.data.details[0].Template
           setAllUserTemplate(response.data.details[1].Template);
           if(response.data.details[1].length!==0){
            templateData[0].accordion[1].accordionServices=response.data.details[1].Template
           }
         
           setTemplateData([...templateData])
        } else {
          setAllUserTemplate([])
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        setShowLoader(false)  
      })
      .catch((err) => console.log("Error"));
  };
  // function getAllUserTemplate(){
  //   setShowLoader(true);
  //   axios
  //     .get(
  //       `${BaseUrl.baseurl}/email-marketing/user-template/get-user-template-details/${
  //         userDetails && userDetails.details._id
  //       }`,
  //       {
  //         headers: {
  //           Authorization: `Bearear ${userDetails && userDetails.token}`,
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       if (response.data.status) {
  //         setAllUserTemplate(response.data.details.Template);
  //         templateData[0].accordion[1].accordionServices=response.data.details.Template
  //         setTemplateData([...templateData])
  //       } else {
  //         setAllUserTemplate([])
  //         if (response.data.tokenExpire) {
  //           localStorage.removeItem("MailSenderuserDetails");
  //           window.location.reload();
  //         }
  //       }
  //       setShowLoader(false)        
  //     })
  //     .catch((err) => console.log("Error"));
  // }
  useEffect(()=>{
    // getAllUserTemplate()
    getAllTemplate()
  },[])

 
  const renameFolderNameTemplate = () => {
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/user-template/update-template-folder-details/${
        userDetails && userDetails.details._id
      }/${selectedFolder._id}`,
      folderName:selectedOption,
      headers: { 
        'Authorization': `Bearear ${userDetails&&userDetails.token}`
      }
    };
    axios.request(config)
    .then((response) => {
      if (response.data.status) {
        console.log("renamed folder name: " + response.data.status)
        getAllTemplate()
        toast.success('Your template folder has been updated successfully!',{autoClose: true,position:"top-right",duration: 3000});
      } else {
        if (response.data.tokenExpire) {
          localStorage.removeItem("MailSenderuserDetails");
          window.location.reload();
        }
      }
    })
    .catch((error) => {
      console.log(error);
      toast.error('Something went wrong please try again later',{autoClose: true,position:"top-right",duration: 3000});
    });
    setOpenDeleteModal(false);
    setShowToast(true)
    setEditFolderName(!editFolderName)
  }
  function createTemplatetoFolder(){
    let tmpData={
      subName:templateName, 
      subTemplate:model
    }
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user-template/add-template-details/${
          userDetails && userDetails.details._id
        }/${selectedFolder._id}`,
        tmpData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setTemplateName('')
          setModel('')
          getAllTemplate()
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
          }
        }
        
      })
      .catch((err) => console.log("Error"));
  }
  function updateTemplatetoFolder(){
    let tmpData={
      subName:templateName, 
      subTemplate:model
    }
    axios
      .put(
        `${BaseUrl.baseurl}/email-marketing/user-template/update-template-details/${
          userDetails && userDetails.details._id
        }/${selectedFolder._id}/${selectedTemplateId}`,
        tmpData,
        {
          headers: {
            Authorization: `Bearear ${userDetails && userDetails.token}`,
          },
        }
      )
      .then((response) => {
        if (response.data.status) {
          setTemplateName('')
          setModel('')
          getAllTemplate()
        } else {
          if (response.data.tokenExpire) {
            localStorage.removeItem("MailSenderuserDetails");
            window.location.reload();
           
          }
        }
        
      })
      .catch((err) => console.log("Error"));
  }
  const onEditorStateChange = (newEditorState) => {
    setEditorState(newEditorState);
  };

  const insertVariable = () => {
    // Get the current editor content
    const currentContent = editorContent;
    // Insert the variable at the cursor position or at the end of the content
    const variableToInsert = '<span class="variable">Your Variable Here</span>';
    const newContent = currentContent + variableToInsert;
    // Set the new content to the editor
    setEditorContent(newContent);
  };

  const toolbarOptions = {
    options: ['history','image','link','emoji','fontFamily','fontSize','inline', 'colorPicker', 'list', 'textAlign',],
    inline: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      bold: {icon: boldSvg, 
      className: undefined },
      options: ['bold', 'italic', 'underline'],
    },
    history:{
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      options: ['undo', 'redo'],
    },
    image: {
      urlEnabled: true,
      uploadEnabled: true,
      alignmentEnabled: true,
      previewImage: false,
      inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
      alt: { present: false, mandatory: false },
      defaultSize: {
        height: 'auto',
        width: 'auto',
      },
    },
    textAlign: {
      inDropdown: false,
      options: ['left']
    },
    link: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      popupClassName: undefined,
      dropdownClassName: undefined,
      showOpenOptionOnHover: true,
      defaultTargetOption: '_self',
      options: ['link'],
      linkCallback: undefined
    },
    list: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      options: ['unordered', 'ordered']
    },
    emoji: {
      className: undefined,
      component: undefined,
      popupClassName: undefined,
      emojis: [
        '😀', '😁', '😂', '😃', '😉', '😋', '😎' 
      ],
    },
    fontSize: {
      inDropdown: true,
      options: [8, 9, 10, 11, 12, 14, 16, 18],
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
    },
    fontFamily: {
      inDropdown: true,
      options: ['Arial', 'Georgia', 'Impact', 'Tahoma'],
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
    },
  }
  
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    setPersonName(value);
  };

 
  
  const createTemplate = () => {
      return (
          <Drawer size='lg' open={openDrawer} onClose={() => setOpenDrawer(false)}>
              <div style={{display:"flex",flexDirection:"column",height:"100%"}}>
                  <div style={{flexShrink:0,padding:"12px 8px",borderBottom:"1px solid #DDD"}}>
                      <p 
                      style={{
                      color: "#393939",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontWeight: 700,
                      fontStyle: "normal"}}>
                      Email</p>
                  </div>
                  <div style={{padding:"8px 16px",display:"flex",flexDirection:"column",gap:"4px"}}>
                        <div style={{display:"flex",flexDirection:"column",gap:"2px",marginBottom:"6px"}}>
                          <p style={{
                              color: "#393939",
                              fontFamily: "Source Sans 3",
                              fontSize: "14px",
                              fontWeight: 400,
                              fontStyle: "normal",}}>Create email template</p>
                        </div>
                        <div style={{display:"flex",flexDirection:"column",gap:"2px"}}>
                            <p style={{
                                color: "#393939",
                                fontFamily: "Source Sans 3",
                                fontSize: "14px",
                                fontWeight: 400,
                                fontStyle: "normal",}}>Name</p>
                            <input value={editableDataObj !== null ? editableDataObj.SubName : templateName} onChange={(e)=>{
                              setTemplateName(e.target.value)
                            }} type="text" style={{border:'1px solid #1C485F',outline:"none",padding:"8px",flexGrow:1,backgroundColor:"transparent",border:"1px solid #DDD",borderRadius:"6px"}} placeholder="Enter something here..."/>
                        </div>
                  </div>
                  <div style={{zIndex:200,position:"relative",flexGrow:1,display:"flex",flexDirection:"row",padding:"0px 16px"}}>
                          <div style={{width:'62vw'}}>
                            {/* <FroalaEditor
                              ref={editorRef}
                              model={model}
                              onModelChange={(e)=>{
                                setModel(e)
                                setEditorContent(e);
                              }}
                              tag='textarea'
                              config={{
                                placeholderText: 'Start type something here....',
                                  zIndex: 10,
                                  toolbarBottom: true,
                                //  toolbarButtons: [['undo','redo','insertFile','insertImage','insertVideo','insertLink','emoticons','fontFamily','fontSize', 'bold', 'italic', 'underline','textColor','formatOL', 'formatUL','alignLeft'],['inlineClass', 'inlineStyle']],
                                // events: {
                                //   // Attach the custom keydown event handler
                                //   'keydown': handleKeyDown,
                                // },
                                }}    
                            />  */}
                            <RichTextEditor 
                                  value={editorValue}
                                  onChange={setEditorValue}
                                  />
                                  <div style={{border:'1px solid black'}}>{editorValue.toString('html')}</div>
                                  <button onClick={handleSave}>Save</button>
                          </div>
                        <div style={{flexShrink:0,width:"160px"}}>
                      <PanelGroup accordion>
                        {editorData.slice(0,3).map((template) => (
                          <div key={template.id}>
                            <Panel
                              header={template.title}
                              eventKey={template.id}
                              id={`panel${template.id}`}
                            >
                              {template.accordionServices.map((service) => (
                                <button
                                  onClick={()=>{
                                    insertHTMLAtCursor(service.text)
                                    setSelectedOption(service.text)
                                  }}
                                  key={service.id}
                                  style={{
                                    outline:'none',
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "12px",
                                    padding: "9px 16px",
                                    cursor: "pointer",
                                    backgroundColor:selectedOption.length > 0 && selectedOption === service.text ? "#FAFAFA" : "#FFF",
                                  }}
                                >
                                  <p
                                    style={{
                                      color: selectedOption.length > 0 && selectedOption === service.text ? "#1C485F" : "#393939",
                                      fontFamily: "Source Sans 3",
                                      fontSize: "13px",
                                      fontWeight: 400,
                                      fontStyle: "normal",
                                      backgroundColor: "transparent",
                                    }}
                                  >
                                    {service.text}
                                  </p>
                                </button>
                              ))}
                            </Panel>
                          </div>
                        ))}
                      </PanelGroup>
                      {
                        editorData.slice(3,editorData.length+1).map(editor=>(
                          <p key={editor.id} 
                          style={{padding:"6px 16px",color: "#393939",
                          fontFamily: "Source Sans 3",
                          fontSize: "13px",
                          fontWeight: 400,
                          fontStyle: "normal",
                          marginTop:"0px"
                          }}>
                            {editor.text}
                          </p>
                        ))
                      }
                    </div>
                  </div>
                  <div style={{alignSelf:"flex-end",backgroundColor:"#FFF",width:"100%",display:"flex",justifyContent:"end",padding:"6px 8px",borderTop:"1px solid #DDD"}}>
                      <button
                          style={{
                          padding: "8px 26px",
                          borderRadius: "4px",
                          color: "#fff",
                          outline: "none",
                          backgroundColor:"#1C485F",
                          alignSelf:"flex-end"
                          }}
                          onClick={() => {
                            // insertVariable()
                            console.log("html content",)
                          // console.log("editor content", draftToHtml(convertToRaw(editorState.getCurrentContent())))
                          // console.log("editor content",editorContent)
                          setOpenDrawer(false)
                          // setShowContent(true)
                          createTemplatetoFolder()
                        }}
                      >
                          Next
                      </button>
                  </div>
              </div>
              <style>
                  {`
                      .rs-drawer-header .rs-drawer-header-close{
                          display: none;
                      }
                  `}
              </style>
          </Drawer>
      )
  }

  const content = `
  <div>
    <p>${modalTitle}</p>
    <p>Stay ahead of the competition. Special offer for
    <span style="color:#1C485F; font-family: 'Source Sans 3'; font-size: 14px; font-weight: 400; font-style: normal;">first_name</span>, <span style="color:#1C485F; font-family: 'Source Sans 3'; font-size: 14px; font-weight: 400; font-style: normal;">Last_name</span></p>
    <p>Hi <span style="color:#1C485F; font-family: 'Source Sans 3'; font-size: 14px; font-weight: 400; font-style: normal;">first_name,</span></p>
    <p>We know it’s not easy <b style="font-size:12px;">[LEAD’S GOAL]</b>.</p>
    <p>Staying ahead of your competition, especially in the [LEAD’S INDUSTRY] industry, is essential. Time has to be spent every single day to make sure you make the right decision and stay on top.</p>
    <p>Efficient. Reliable. Trustworthy. These are just a few things you become when you don’t have to spend hours <b style="font-size:12px;">[LEAD’S PAIN POINT]. [YOUR COMPANY NAME]</b> is here for you. <b style="font-size:12px;">[NAME AND VERY SHORT PITCH]</b> is the solution you’ve been looking for.</p>
    <p>Let us help you get back into rhythm. Your time and effort deserve to be matched with the prowess of <b style="font-size:12px;">[YOUR COMPANY NAME]</b>.</p>
    <p>Reply to schedule a demo with our specialist now.</p>
    <p>Best regards,<br/><b style="font-size:12px;">[YOUR NAME], [YOUR POSITION] at [COMPANY NAME]</b></p>
  </div>
`;

  const handleDeleteTemplate = () => {
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/user-template/remove-template-details/${userDetails && userDetails.details._id}/${selectedFolder._id}/${selectedTemplateId}`,
      headers: { 
        'Authorization': `Bearear ${userDetails&&userDetails.token}`
      }
    };
    axios.request(config)
    .then((response) => {
      if (response.data.status) {
        console.log("deleted template: " + response.data.status)
        getAllTemplate()
        setSelectedOption("")
        toast.success('Your template has been deleted successfully!',{autoClose: true,position:"top-right",duration: 3000});
      } else {
        if (response.data.tokenExpire) {
          localStorage.removeItem("MailSenderuserDetails");
          window.location.reload();
        }
      }
    })
    .catch((error) => {
      console.log(error);
      toast.error('Something went wrong please try again later',{autoClose: true,position:"top-right",duration: 3000});
    });
    setOpenDeleteModal(false);
    setShowToast(true)
  }

  const handleDeleteFolder = () => {
    let config = {
      method: 'put',
      maxBodyLength: Infinity,
      url: `${BaseUrl.baseurl}/email-marketing/user-template/remove-template-folder/${userDetails && userDetails.details._id}/${selectedFolder._id}`,
      headers: { 
        'Authorization': `Bearear ${userDetails&&userDetails.token}`
      }
    };
    axios.request(config)
    .then((response) => {
      if (response.data.status) {
        console.log("deleted template: " + response.data.status)
        getAllTemplate()
        toast.success('Your template folder has been deleted successfully!',{autoClose: true,position:"top-right",duration: 3000});
        history.push("/All-Campaign/Templates")
      } else {
        if (response.data.tokenExpire) {
          localStorage.removeItem("MailSenderuserDetails");
          window.location.reload();
        }
      }
    })
    .catch((error) => {
      console.log(error);
      toast.error('Something went wrong please try again later',{autoClose: true,position:"top-right",duration: 3000});
    });
    setOpenDeleteFolderModal(false);
    setShowToast(true);
  }

  const deleteModal = () => {
    return (
      <div>
        <Modal
          open={openDeleteModal}
          onClose={() => setOpenDeleteModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid transparent",
            borderRadius: "7px",
            boxShadow: 24,
            p: 2,
            display:"flex",
            flexDirection:"column",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <svg
              style={{ alignSelf: "center", marginBottom: "10px" }}
              xmlns="http://www.w3.org/2000/svg"
              width="95"
              height="94"
              viewBox="0 0 95 94"
              fill="none"
            >
              <path
                d="M47.5005 35.2506V50.9172M17.6512 59.5331C14.0893 65.7026 12.3088 68.7885 12.5748 71.3197C12.8069 73.5276 13.9657 75.5335 15.7617 76.8384C17.8201 78.3339 21.3799 78.3339 28.4989 78.3339H66.5021C73.6211 78.3339 77.1803 78.3339 79.2387 76.8384C81.0348 75.5335 82.1941 73.5276 82.4261 71.3197C82.6922 68.7885 80.9122 65.7026 77.3503 59.5331L58.3555 26.6331C54.7935 20.4637 53.0118 17.3794 50.6866 16.3442C48.6585 15.4412 46.3412 15.4412 44.3131 16.3442C41.9889 17.379 40.2082 20.4632 36.6492 26.6276L17.6512 59.5331ZM47.6994 62.6672V63.0589L47.3054 63.0596V62.6672H47.6994Z"
                stroke="#FFCB2F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <h1
              style={{
                lineHeight: "12px",
                color: "#4b4b4b",
                fontFamily: "Source Sans 3",
                fontSize: "18px",
                fontWeight: 700,
                fontStyle: "normal",
              }}
            >
              Template deletion
            </h1>
            <p
              style={{
                padding: "16px 0px",
                color: "#868686",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontWeight: 400,
                fontStyle: "normal",
                maxWidth:"300px",
                textAlign: "center",
              }}
            >
              Are you sure you want to delete this template? This action is irreversible.
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "12px",
                gap: "22px",
              }}
            >
              <Button
                disableRipple
                disableElevation
                onClick={() => setOpenDeleteModal(false)}
                sx={{
                  textTransform: "none",
                  border: "1px solid #1C485F",
                  outline: "none !important",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  "&:hover": {
                    background: "transparent !important",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDeleteTemplate}
                disableRipple
                disableElevation
                style={{
                  textTransform: "none",
                  background: "#1C485F",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                Yes,Delete it
              </Button>
            </div>
            <Button
              disableRipple
              disableElevation
              onClick={() => setOpenDeleteModal(false)}
              sx={{
                textTransform: "none",
                outline: "none !important",
                padding: "9px 16px",
                fontSize: "14px",
                fontWeight: "400",
                position: "absolute",
                top: 0,
                right: 0,
                "&:hover": {
                  background: "transparent !important",
                },
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.16992 14.8299L14.8299 9.16992"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.8299 14.8299L9.16992 9.16992"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Button>
          </Box>
        </Modal>
      </div>
    );
  };

  const deleteFolderModal = () => {
    return (
      <div>
        <Modal
          open={openDeleteFolderModal}
          onClose={() => setOpenDeleteFolderModal(false)}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "background.paper",
            border: "2px solid transparent",
            borderRadius: "7px",
            boxShadow: 24,
            p: 2,
            display:"flex",
            flexDirection:"column",
            justifyContent: "center",
            alignItems: "center",
          }}>
            <svg
              style={{ alignSelf: "center", marginBottom: "10px" }}
              xmlns="http://www.w3.org/2000/svg"
              width="95"
              height="94"
              viewBox="0 0 95 94"
              fill="none"
            >
              <path
                d="M47.5005 35.2506V50.9172M17.6512 59.5331C14.0893 65.7026 12.3088 68.7885 12.5748 71.3197C12.8069 73.5276 13.9657 75.5335 15.7617 76.8384C17.8201 78.3339 21.3799 78.3339 28.4989 78.3339H66.5021C73.6211 78.3339 77.1803 78.3339 79.2387 76.8384C81.0348 75.5335 82.1941 73.5276 82.4261 71.3197C82.6922 68.7885 80.9122 65.7026 77.3503 59.5331L58.3555 26.6331C54.7935 20.4637 53.0118 17.3794 50.6866 16.3442C48.6585 15.4412 46.3412 15.4412 44.3131 16.3442C41.9889 17.379 40.2082 20.4632 36.6492 26.6276L17.6512 59.5331ZM47.6994 62.6672V63.0589L47.3054 63.0596V62.6672H47.6994Z"
                stroke="#FFCB2F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            <h1
              style={{
                lineHeight: "12px",
                color: "#4b4b4b",
                fontFamily: "Source Sans 3",
                fontSize: "18px",
                fontWeight: 700,
                fontStyle: "normal",
              }}
            >
              Warning
            </h1>
            <p
              style={{
                padding: "16px 0px",
                color: "#868686",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontWeight: 400,
                fontStyle: "normal",
                maxWidth:"300px",
                textAlign: "center",
              }}
            >
              Are you sure?
            </p>
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                paddingTop: "12px",
                gap: "22px",
              }}
            >
              <Button
                disableRipple
                disableElevation
                onClick={() => setOpenDeleteFolderModal(false)}
                sx={{
                  textTransform: "none",
                  border: "1px solid #1C485F",
                  outline: "none !important",
                  color: "#1C485F",
                  padding: "9px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                  "&:hover": {
                    background: "transparent !important",
                  },
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleDeleteFolder}
                disableRipple
                disableElevation
                style={{
                  textTransform: "none",
                  background: "#1C485F",
                  outline: "none",
                  color: "#fff",
                  padding: "10px 16px",
                  fontSize: "14px",
                  fontWeight: "400",
                }}
              >
                Ok
              </Button>
            </div>
            <Button
              disableRipple
              disableElevation
              onClick={() => setOpenDeleteFolderModal(false)}
              sx={{
                textTransform: "none",
                outline: "none !important",
                padding: "9px 16px",
                fontSize: "14px",
                fontWeight: "400",
                position: "absolute",
                top: 0,
                right: 0,
                "&:hover": {
                  background: "transparent !important",
                },
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.16992 14.8299L14.8299 9.16992"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.8299 14.8299L9.16992 9.16992"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Button>
          </Box>
        </Modal>
      </div>
    );
  };

  const muiModal = () => {
      return (
        <Modal
          aria-labelledby="transition-modal-title"
          aria-describedby="transition-modal-description"
          open={openModal}
          onClose={() => setOpenModal(false)}
          closeAfterTransition
          slots={{ backdrop: Backdrop }}
          slotProps={{
            backdrop: {
              timeout: 500,
            },
          }}
        >
          <Fade in={openModal}>
            <Box sx={style}>
              <div style={{height:"100%",overflowY:'scroll'}} dangerouslySetInnerHTML={{ __html: templateEmail }}></div>
            <Button
              disableRipple
              disableElevation
              sx={{
                display: "flex",
                outline: "none !important",
                justifyContent: "flex-end",
                padding: "0px",
                "&:hover": {
                  background: "transparent !important",
                },
                position: "absolute",
                top:10,
                right:10,
              }}
              onClick={() => setOpenModal(false)}
            >
              <span className="sr-only">Close</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="22"
                height="22"
                viewBox="0 0 24 24"
                fill="none"
              >
                <path
                  d="M12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22Z"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M9.16992 14.8299L14.8299 9.16992"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M14.8299 14.8299L9.16992 9.16992"
                  stroke="black"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </Button>
            </Box>
            
          </Fade>
        </Modal>
      );
  };

  const optionsUi = () => {
      return(
          <div style={{ backgroundColor: "#FFF", borderRadius: "10px",}}>
          <Box
              sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "4px 16px",
                  borderBottomWidth: "1.2px",
              }}
              >
              <div style={{display:"flex",alignItems:"center",gap:"32px"}}>
                {
                  editFolderName ?
                  <>
                    <Button
                    disableRipple
                    disableElevation
                    sx={{
                    cursor: "default",
                    outline: "none !important",
                    borderBottom: "2px solid #1C485F",
                    borderRadius: 0,
                    color: "#1C485F",
                    textTransform: "none",
                    "&:hover": {
                        backgroundColor: "transparent",
                    },
                    }}
                >
                  
                    <Typography
                      style={{
                          color: "#1C485F",
                          fontSize: "15px",
                          fontWeight: 700,
                          fontFamily: "Source Sans 3",
                      }}
                      component="h2"
                      >
                      {selectedFolder.Name}
                    </Typography>
                    </Button> 
                    <div style={{display:"flex",gap:"30px",alignItems:"center"}}> 
                    <Tooltip arrow placement="right" title="Edit folder name">
                      <button style={{outline:"none"}} onClick={()=>{
                        setEditFolderName(!editFolderName)
                      }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25" fill="none">
                        <path d="M11.7148 2.96069H9.71484C4.71484 2.96069 2.71484 4.96069 2.71484 9.96069V15.9607C2.71484 20.9607 4.71484 22.9607 9.71484 22.9607H15.7148C20.7148 22.9607 22.7148 20.9607 22.7148 15.9607V13.9607" stroke="#868686" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M16.7547 3.9807L8.87472 11.8607C8.57472 12.1607 8.27472 12.7507 8.21472 13.1807L7.78472 16.1907C7.62472 17.2807 8.39472 18.0407 9.48472 17.8907L12.4947 17.4607C12.9147 17.4007 13.5047 17.1007 13.8147 16.8007L21.6947 8.9207C23.0547 7.5607 23.6947 5.9807 21.6947 3.9807C19.6947 1.9807 18.1147 2.6207 16.7547 3.9807Z" stroke="#868686" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M15.625 5.11072C16.295 7.50072 18.165 9.37072 20.565 10.0507" stroke="#868686" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                      </svg>
                      </button>
                    </Tooltip>
                    <Tooltip arrow placement="right" title="Delete folder name">
                      <button style={{outline:"none"}} onClick={()=>setOpenDeleteFolderModal(true)}>
                        <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                          stroke="#393939"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                          stroke="#393939"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M18.8504 9.13965L18.2004 19.2096C18.0904 20.7796 18.0004 21.9996 15.2104 21.9996H8.79039C6.00039 21.9996 5.91039 20.7796 5.80039 19.2096L5.15039 9.13965"
                          stroke="#393939"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M10.3301 16.5H13.6601"
                          stroke="#393939"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M9.5 12.5H14.5"
                          stroke="#393939"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        </svg>
                      </button>
                    </Tooltip>
                    </div>
                  </> 
                  :
                  <div style={{display:"flex",alignItems:"center",gap:"20px"}}>
                    <input value={selectedOption} onChange={(e)=>setSelectedOption(e.target.value)} type="text" style={{padding:"12px",backgroundColor:"#FAFAFA",borderRadius:"4px",outline:"none",width:"180px"}}/>
                    <button onClick={renameFolderNameTemplate} style={{border:'1px solid #1C485F',padding:"8px 12px",backgroundColor:"#1C485F",color:"#FFF",borderRadius:"4px",outline:"none"}}>
                      Ok
                    </button>
                  </div>
                }
                
                
              </div>
              <div style={{display:"flex",alignItems:"center",gap:"12px"}}>
                <button
                    style={{
                        fontSize: "12px",
                        outline: "none",
                        color: "#1C485F",
                        padding: "8px 10px",
                    }}
                    >
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                        <path d="M9.58268 17.4993C13.9549 17.4993 17.4993 13.9549 17.4993 9.58268C17.4993 5.21043 13.9549 1.66602 9.58268 1.66602C5.21043 1.66602 1.66602 5.21043 1.66602 9.58268C1.66602 13.9549 5.21043 17.4993 9.58268 17.4993Z" stroke="#868686" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                        <path d="M18.3327 18.3327L16.666 16.666" stroke="#868686" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                </button>
                <button
                    onClick={()=>{
                      setEditableDataObj(null)
                      setOpenDrawer(true)}}
                    style={{
                        fontSize: "12px",
                        borderRadius: "5px",
                        outline: "none",
                        border: "1.5px solid #1C485F",
                        color: "#1C485F",
                        padding: "8px 10px",
                    }}
                    >
                    Create email template
                </button>
              </div>
          </Box>
          <div style={{padding:"14px"}}>
              <div 
              style={{width:"100%",padding:"10px 8px",color: "#393939",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontWeight: 700,
                fontStyle: "normal",
                backgroundColor:"#FAFAFA",
                borderRadius:"10px"
                }}>
                      Name
              </div>
              {
                  selectedTemplateArray.map((data,idx)=>(
                  <div key={data._id}  style={{backgroundColor:idx % 2 === 0 ?"#FFF":"#FAFAFA",borderRadius:"10px"}}>
                      <div style={{width:"100%",padding:"10px 8px",display:"flex",justifyContent:"space-between",alignItems:"center"}}>
                          <p 
                          onClick={()=>{
                              setModalTitle(data.SubName)
                              setTemplateEmail(data.SubTemplate)
                              setOpenModal(true)
                              
                          }}
                          style={{color: "#1C485F",
                          fontFamily: "Source Sans 3",
                          fontSize: "16px",
                          fontWeight: 400,
                          cursor: "pointer",
                          fontStyle: "normal"}}>{data.SubName}</p>
                          <div style={{display:"flex",gap:"30px",alignItems:"center"}}> 
                            <button onClick={()=>{
                              setOpenDrawer(true)
                              setEditableDataObj(data)
                            }} style={{outline:"none"}}>
                              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 25 25" fill="none">
                                <path d="M11.7148 2.96069H9.71484C4.71484 2.96069 2.71484 4.96069 2.71484 9.96069V15.9607C2.71484 20.9607 4.71484 22.9607 9.71484 22.9607H15.7148C20.7148 22.9607 22.7148 20.9607 22.7148 15.9607V13.9607" stroke="#868686" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M16.7547 3.9807L8.87472 11.8607C8.57472 12.1607 8.27472 12.7507 8.21472 13.1807L7.78472 16.1907C7.62472 17.2807 8.39472 18.0407 9.48472 17.8907L12.4947 17.4607C12.9147 17.4007 13.5047 17.1007 13.8147 16.8007L21.6947 8.9207C23.0547 7.5607 23.6947 5.9807 21.6947 3.9807C19.6947 1.9807 18.1147 2.6207 16.7547 3.9807Z" stroke="#868686" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                                <path d="M15.625 5.11072C16.295 7.50072 18.165 9.37072 20.565 10.0507" stroke="#868686" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
                              </svg>
                            </button>
                            <button onClick={()=>{
                              setOpenDeleteModal(true)
                              setSelectedTemplateId(data._id)
                            }} style={{outline:"none"}}>
                              <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 24 24"
                              fill="none"
                            >
                              <path
                                d="M21 5.98047C17.67 5.65047 14.32 5.48047 10.98 5.48047C9 5.48047 7.02 5.58047 5.04 5.78047L3 5.98047"
                                stroke="#393939"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8.5 4.97L8.72 3.66C8.88 2.71 9 2 10.69 2H13.31C15 2 15.13 2.75 15.28 3.67L15.5 4.97"
                                stroke="#393939"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M18.8504 9.13965L18.2004 19.2096C18.0904 20.7796 18.0004 21.9996 15.2104 21.9996H8.79039C6.00039 21.9996 5.91039 20.7796 5.80039 19.2096L5.15039 9.13965"
                                stroke="#393939"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M10.3301 16.5H13.6601"
                                stroke="#393939"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M9.5 12.5H14.5"
                                stroke="#393939"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              </svg>
                            </button>
                          </div>
                      </div>
                  </div>
                  ))
              }
              {selectedTemplateArray.length === 0 && 
                <div style={{display:"flex",flexDirection:"column",alignItems:"center",gap:"12px",padding:"12px 0px"}}>
                  <div style={{display:"flex",alignItems:"center",justifyContent:"center"}}>
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="240"
                        height="227"
                        viewBox="0 0 240 227"
                        fill="none"
                      >
                        <path d="M240 183.553H0V183.673H240V183.553Z" fill="#EBEBEB" />
                        <path
                          d="M215.952 191.275H200.055V191.395H215.952V191.275Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M158.986 192.582H154.814V192.702H158.986V192.582Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M199.574 186.82H190.363V186.94H199.574V186.82Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M45.9128 187.627H25.1816V187.747H45.9128V187.627Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M53.2279 187.627H50.1895V187.747H53.2279V187.627Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M108.072 189.652H63.1055V189.772H108.072V189.652Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M113.759 162.144H21.0758C20.3498 162.143 19.6539 161.854 19.1409 161.34C18.6279 160.826 18.3398 160.13 18.3398 159.404V29.1172C18.3462 28.3953 18.6371 27.705 19.1493 27.1963C19.6616 26.6877 20.3539 26.4016 21.0758 26.4004H113.759C114.486 26.4004 115.183 26.6892 115.697 27.2032C116.211 27.7172 116.5 28.4143 116.5 29.1412V159.404C116.5 160.13 116.211 160.828 115.697 161.342C115.183 161.856 114.486 162.144 113.759 162.144ZM21.0758 26.4964C20.3816 26.4977 19.7162 26.7743 19.2258 27.2657C18.7353 27.7571 18.4598 28.4229 18.4598 29.1172V159.404C18.4598 160.098 18.7353 160.764 19.2258 161.255C19.7162 161.746 20.3816 162.023 21.0758 162.024H113.759C114.454 162.023 115.12 161.747 115.611 161.255C116.102 160.764 116.379 160.098 116.38 159.404V29.1172C116.379 28.4225 116.102 27.7566 115.611 27.2654C115.12 26.7742 114.454 26.4977 113.759 26.4964H21.0758Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M217.589 162.144H124.901C124.174 162.143 123.478 161.854 122.964 161.34C122.451 160.827 122.161 160.13 122.16 159.404V29.1172C122.168 28.3948 122.46 27.7046 122.973 27.196C123.486 26.6875 124.179 26.4016 124.901 26.4004H217.589C218.31 26.4029 219.001 26.6895 219.512 27.198C220.024 27.7066 220.314 28.3961 220.32 29.1172V159.404C220.32 160.129 220.033 160.825 219.521 161.338C219.009 161.852 218.314 162.142 217.589 162.144ZM124.901 26.4964C124.206 26.4977 123.54 26.7742 123.049 27.2654C122.558 27.7566 122.281 28.4225 122.28 29.1172V159.404C122.281 160.098 122.558 160.764 123.049 161.255C123.54 161.747 124.206 162.023 124.901 162.024H217.589C218.284 162.023 218.95 161.747 219.441 161.255C219.932 160.764 220.208 160.098 220.21 159.404V29.1172C220.208 28.4225 219.932 27.7566 219.441 27.2654C218.95 26.7742 218.284 26.4977 217.589 26.4964H124.901Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M139.051 83.5488L205.186 83.5488V40.2384L139.051 40.2384V83.5488Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M137.031 83.5488L204.24 83.5488V40.2384L137.031 40.2384V83.5488Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M139.051 92.0449L205.186 92.0449V83.5441L139.051 83.5441V92.0449Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M133.675 92.0449L200.885 92.0449V83.5441L133.675 83.5441V92.0449Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M201.418 80.7272V43.0664L139.858 43.0664V80.7272H201.418Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M187.535 80.7224L179.673 43.0664H167.404L175.267 80.7224H187.535Z"
                          fill="white"
                        />
                        <path
                          d="M200.112 77.9144C200.139 77.9144 200.165 77.909 200.19 77.8986C200.215 77.8882 200.237 77.8729 200.256 77.8536C200.275 77.8344 200.29 77.8116 200.299 77.7866C200.309 77.7616 200.314 77.7349 200.313 77.708V44.9048C200.313 44.8513 200.292 44.8 200.254 44.7622C200.217 44.7244 200.165 44.7032 200.112 44.7032C200.085 44.7025 200.059 44.7073 200.034 44.7172C200.009 44.7271 199.987 44.7419 199.968 44.7608C199.949 44.7796 199.934 44.8021 199.924 44.8269C199.914 44.8516 199.91 44.8781 199.91 44.9048V77.708C199.91 77.7349 199.914 77.7616 199.924 77.7866C199.934 77.8116 199.949 77.8344 199.968 77.8536C199.986 77.8729 200.009 77.8882 200.034 77.8986C200.058 77.909 200.085 77.9144 200.112 77.9144Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M172.632 80.7224L164.77 43.0664H159.984L167.852 80.7224H172.632Z"
                          fill="white"
                        />
                        <path
                          d="M140.217 80.7272V43.0664H139.857V80.7272H140.217Z"
                          fill="#E6E6E6"
                        />
                        <path
                          opacity="0.6"
                          d="M136.367 47.3234H202.502L202.761 44.1602H136.626L136.367 47.3234Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M136.367 52.508H202.502L202.761 49.3496H136.626L136.367 52.508Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M136.367 57.6916H202.502L202.761 54.5332H136.626L136.367 57.6916Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M136.367 62.88H202.502L202.761 59.7168H136.626L136.367 62.88Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M136.367 68.0636H202.502L202.761 64.9004H136.626L136.367 68.0636Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M136.367 73.2491H202.502L202.761 70.0859H136.626L136.367 73.2491Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M195.691 152.055H181.824V154.791H195.691V152.055Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M155.668 183.553H158.227V120.639H155.668V183.553Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M146.798 154.791H181.818V152.055H146.798V154.791Z"
                          fill="#F5F5F5"
                        />
                        <path
                          d="M195.691 167.016H181.824V169.752H195.691V167.016Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M146.798 169.748H181.818V167.012H146.798V169.748Z"
                          fill="#F5F5F5"
                        />
                        <path
                          d="M195.691 122.137H181.824V124.873H195.691V122.137Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M146.798 124.867H181.818V122.131H146.798V124.867Z"
                          fill="#F5F5F5"
                        />
                        <path
                          d="M195.691 137.094H181.824V139.83H195.691V137.094Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M146.798 139.83H181.818V137.094H146.798V139.83Z"
                          fill="#F5F5F5"
                        />
                        <path
                          d="M190.694 183.553H193.252V120.639H190.694V183.553Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M179.26 183.553H181.818V120.639H179.26V183.553Z"
                          fill="#F5F5F5"
                        />
                        <path
                          d="M146.799 183.553H149.357V120.639H146.799V183.553Z"
                          fill="#F5F5F5"
                        />
                        <path
                          d="M31.3817 183.553H57.5801L57.5801 132.726H31.3817L31.3817 183.553Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M38.3753 183.553H31.377V176.535H45.7098L38.3753 183.553Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M102.805 183.553H129.004V132.726H102.805V183.553Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M31.3816 181.133H108.916V132.72H31.3816V181.133Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M101.918 183.553H108.912V176.535H94.584L101.918 183.553Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M36.8067 162.879H103.488V150.764H36.8067V162.879Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M36.8067 177.582H103.488V165.467H36.8067V177.582Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M90.8162 152.061H49.4834C48.9003 152.061 48.3411 151.829 47.9289 151.417C47.5166 151.004 47.285 150.445 47.285 149.862V149.713H93.0098V149.862C93.0098 150.444 92.7788 151.003 92.3676 151.415C91.9563 151.827 91.3984 152.059 90.8162 152.061Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M36.8067 148.172H103.488V136.057H36.8067V148.172Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M90.8162 137.352H49.4834C48.9003 137.352 48.3411 137.12 47.9289 136.708C47.5166 136.295 47.285 135.736 47.285 135.153V135.004H93.0098V135.153C93.0098 135.735 92.7788 136.294 92.3676 136.706C91.9563 137.118 91.3984 137.35 90.8162 137.352Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M90.8162 166.768H49.4834C48.9003 166.768 48.3411 166.536 47.9289 166.124C47.5166 165.711 47.285 165.152 47.285 164.569V164.42H93.0098V164.569C93.0098 165.151 92.7788 165.71 92.3676 166.122C91.9563 166.534 91.3984 166.766 90.8162 166.768Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M35.5531 83.5488L101.688 83.5488V40.2384L35.5531 40.2384V83.5488Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M33.5384 83.5488L100.748 83.5488V40.2384L33.5384 40.2384V83.5488Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M35.5531 92.0449L101.688 92.0449V83.5441L35.5531 83.5441V92.0449Z"
                          fill="#E6E6E6"
                        />
                        <path
                          d="M30.1732 92.0449L97.3828 92.0449V83.5441L30.1732 83.5441V92.0449Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M97.9199 80.7272V43.0664L36.3599 43.0664V80.7272H97.9199Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M84.0375 80.7224L76.175 43.0664H63.9062L71.7687 80.7224H84.0375Z"
                          fill="white"
                        />
                        <path
                          d="M96.6099 77.9144C96.6367 77.9144 96.6634 77.909 96.6881 77.8986C96.7129 77.8882 96.7353 77.8729 96.7541 77.8536C96.7729 77.8344 96.7877 77.8116 96.7975 77.7866C96.8074 77.7616 96.8121 77.7349 96.8115 77.708V44.9048C96.8121 44.8781 96.8074 44.8516 96.7975 44.8269C96.7876 44.8021 96.7727 44.7796 96.7539 44.7608C96.735 44.7419 96.7125 44.7271 96.6878 44.7172C96.663 44.7073 96.6365 44.7025 96.6099 44.7032C96.5564 44.7032 96.5051 44.7244 96.4673 44.7622C96.4295 44.8 96.4083 44.8513 96.4083 44.9048V77.708C96.4076 77.7349 96.4124 77.7616 96.4222 77.7866C96.432 77.8116 96.4468 77.8344 96.4656 77.8536C96.4844 77.8729 96.5068 77.8882 96.5316 77.8986C96.5564 77.909 96.583 77.9144 96.6099 77.9144Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M69.1343 80.7224L61.2719 43.0664H56.4863L64.3487 80.7224H69.1343Z"
                          fill="white"
                        />
                        <path
                          d="M36.7207 80.7272V43.0664H36.3607V80.7272H36.7207Z"
                          fill="#E6E6E6"
                        />
                        <path
                          opacity="0.6"
                          d="M32.8652 47.3234H98.9996L99.2588 44.1602H33.1244L32.8652 47.3234Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M32.8652 49.1085H98.9996L99.2588 45.9453H33.1244L32.8652 49.1085Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M32.8652 50.8908H98.9996L99.2588 47.7324H33.1244L32.8652 50.8908Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M32.8652 52.6749H98.9996L99.2588 49.5117H33.1244L32.8652 52.6749Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M32.8652 54.4572H98.9996L99.2588 51.2988H33.1244L32.8652 54.4572Z"
                          fill="#EBEBEB"
                        />
                        <path
                          opacity="0.6"
                          d="M32.8652 56.2413H98.9996L99.2588 53.0781H33.1244L32.8652 56.2413Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M46.0902 131.17H48.375V105.687H46.0902V131.17Z"
                          fill="#F5F5F5"
                        />
                        <path
                          d="M46.3774 131.156H47.0254V105.673H46.3774V131.156Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M47.2944 131.156H47.5488V105.673H47.2944V131.156Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M55.6953 132.725H38.7801C38.7801 132.159 39.0047 131.617 39.4043 131.218C39.804 130.818 40.3461 130.593 40.9113 130.593H53.5593C54.1245 130.593 54.6666 130.818 55.0663 131.218C55.466 131.617 55.6905 132.159 55.6905 132.725H55.6953Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M43.1233 121.507C43.2974 121.506 43.4639 121.436 43.5869 121.313C43.71 121.19 43.7797 121.023 43.7809 120.849V104.16C43.7809 103.985 43.7117 103.818 43.5883 103.695C43.465 103.571 43.2977 103.502 43.1233 103.502C43.0366 103.501 42.9505 103.518 42.8702 103.551C42.7899 103.583 42.7168 103.632 42.6552 103.693C42.5937 103.754 42.5448 103.827 42.5114 103.907C42.4781 103.987 42.4609 104.073 42.4609 104.16V120.868C42.4672 121.04 42.5397 121.202 42.6632 121.321C42.7868 121.44 42.9517 121.507 43.1233 121.507Z"
                          fill="#F0F0F0"
                        />
                        <path
                          d="M36.9941 111.743H57.4661L55.1093 97.4395H39.3509L36.9941 111.743Z"
                          fill="#E0E0E0"
                        />
                        <path
                          d="M120.001 205.229C171.4 205.229 213.068 202.796 213.068 199.795C213.068 196.794 171.4 194.361 120.001 194.361C68.6012 194.361 26.9336 196.794 26.9336 199.795C26.9336 202.796 68.6012 205.229 120.001 205.229Z"
                          fill="#F5F5F5"
                        />
                        <path
                          d="M49.9768 97.1335L49.498 97.168L50.1357 106.02L50.6145 105.986L49.9768 97.1335Z"
                          fill="#393939"
                        />
                        <path
                          d="M50.9397 110.555L50.4609 110.59L50.701 113.922L51.1797 113.888L50.9397 110.555Z"
                          fill="#393939"
                        />
                        <path
                          d="M162.101 151.277H59.3044C58.1601 151.257 57.064 150.813 56.2273 150.032C55.3906 149.251 54.8726 148.188 54.7732 147.048L49.7236 76.9059C49.6766 76.365 49.7435 75.8202 49.9198 75.3067C50.0962 74.7931 50.3782 74.3222 50.7477 73.9243C51.1171 73.5264 51.5658 73.2102 52.0648 72.9963C52.5639 72.7823 53.1022 72.6752 53.6452 72.6819H156.442C157.585 72.7024 158.681 73.1452 159.518 73.925C160.354 74.7049 160.873 75.7667 160.973 76.9059L166.023 147.048C166.07 147.59 166.003 148.135 165.826 148.648C165.65 149.162 165.368 149.633 164.999 150.032C164.629 150.43 164.181 150.746 163.682 150.961C163.183 151.175 162.644 151.283 162.101 151.277Z"
                          fill="#393939"
                        />
                        <path
                          d="M162.494 151.277H59.6969C58.5527 151.257 57.4565 150.813 56.6198 150.032C55.7832 149.251 55.2652 148.188 55.1657 147.048L50.1161 76.9059C50.0692 76.365 50.136 75.8202 50.3124 75.3067C50.4888 74.7931 50.7708 74.3222 51.1402 73.9243C51.5097 73.5264 51.9584 73.2102 52.4574 72.9963C52.9565 72.7823 53.4948 72.6752 54.0377 72.6819H156.835C157.978 72.7024 159.074 73.1452 159.91 73.925C160.747 74.7049 161.265 75.7667 161.366 76.9059L166.415 147.048C166.463 147.59 166.397 148.135 166.221 148.649C166.045 149.163 165.763 149.635 165.393 150.033C165.024 150.432 164.575 150.748 164.075 150.962C163.576 151.177 163.037 151.284 162.494 151.277Z"
                          fill="#393939"
                        />
                        <path
                          opacity="0.5"
                          d="M162.494 151.277H59.6969C58.5527 151.257 57.4565 150.813 56.6198 150.032C55.7832 149.251 55.2652 148.188 55.1657 147.048L50.1161 76.9059C50.0692 76.365 50.136 75.8202 50.3124 75.3067C50.4888 74.7931 50.7708 74.3222 51.1402 73.9243C51.5097 73.5264 51.9584 73.2102 52.4574 72.9963C52.9565 72.7823 53.4948 72.6752 54.0377 72.6819H156.835C157.978 72.7024 159.074 73.1452 159.91 73.925C160.747 74.7049 161.265 75.7667 161.366 76.9059L166.415 147.048C166.463 147.59 166.397 148.135 166.221 148.649C166.045 149.163 165.763 149.635 165.393 150.033C165.024 150.432 164.575 150.748 164.075 150.962C163.576 151.177 163.037 151.284 162.494 151.277Z"
                          fill="white"
                        />
                        <path
                          d="M156.988 74.7949H54.1913H53.8457C51.2201 75.0109 51.7577 79.0093 54.4073 79.0093H157.377C160.031 79.0093 159.993 75.0109 157.334 74.7949H156.988Z"
                          fill="#393939"
                        />
                        <path
                          d="M56.8699 76.9054C56.88 77.0291 56.864 77.1536 56.823 77.2708C56.782 77.388 56.7169 77.4953 56.6318 77.5858C56.5468 77.6762 56.4437 77.7479 56.3293 77.796C56.2149 77.8442 56.0916 77.8678 55.9675 77.8654C55.7066 77.8617 55.4563 77.7616 55.2648 77.5844C55.0734 77.4071 54.9544 77.1652 54.9307 76.9054C54.9206 76.7821 54.9365 76.658 54.9772 76.5411C55.0179 76.4243 55.0826 76.3172 55.1671 76.2268C55.2516 76.1364 55.3541 76.0647 55.4679 76.0163C55.5818 75.9678 55.7045 75.9437 55.8283 75.9454C56.09 75.9479 56.3414 76.0475 56.5339 76.2248C56.7264 76.4022 56.8461 76.6448 56.8699 76.9054Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M60.1687 76.9054C60.1788 77.0291 60.1628 77.1536 60.1218 77.2708C60.0808 77.388 60.0157 77.4953 59.9307 77.5858C59.8456 77.6762 59.7426 77.7479 59.6281 77.796C59.5137 77.8442 59.3904 77.8678 59.2663 77.8654C59.0054 77.8617 58.7551 77.7616 58.5637 77.5844C58.3722 77.4071 58.2532 77.1652 58.2295 76.9054C58.2194 76.7821 58.2353 76.658 58.276 76.5411C58.3167 76.4243 58.3814 76.3172 58.4659 76.2268C58.5504 76.1364 58.6529 76.0647 58.7668 76.0163C58.8806 75.9678 59.0034 75.9437 59.1271 75.9454C59.3888 75.9479 59.6403 76.0475 59.8327 76.2248C60.0252 76.4022 60.1449 76.6448 60.1687 76.9054Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M63.4612 76.9055C63.4713 77.0288 63.4554 77.1529 63.4147 77.2698C63.374 77.3866 63.3093 77.4937 63.2248 77.5841C63.1403 77.6744 63.0378 77.7462 62.9239 77.7946C62.8101 77.8431 62.6873 77.8672 62.5636 77.8655C62.3024 77.8629 62.0515 77.7631 61.8599 77.5857C61.6682 77.4082 61.5494 77.1657 61.5268 76.9055C61.516 76.782 61.5313 76.6576 61.5717 76.5404C61.6122 76.4232 61.6768 76.3159 61.7615 76.2253C61.8462 76.1348 61.949 76.063 62.0632 76.0148C62.1774 75.9666 62.3005 75.943 62.4244 75.9455C62.6853 75.9492 62.9356 76.0493 63.127 76.2265C63.3185 76.4038 63.4375 76.6457 63.4612 76.9055Z"
                          fill="#FAFAFA"
                        />
                        <path
                          d="M159.768 144.279H61.4403C61.0249 144.272 60.6269 144.111 60.3236 143.827C60.0202 143.543 59.8332 143.157 59.7987 142.743L55.6467 85.0612C55.6282 84.8633 55.652 84.6637 55.7166 84.4756C55.7812 84.2876 55.885 84.1155 56.0212 83.9707C56.1574 83.8259 56.3228 83.7117 56.5065 83.6357C56.6902 83.5597 56.888 83.5237 57.0867 83.53H155.439C155.854 83.5357 156.252 83.6957 156.555 83.9787C156.859 84.2618 157.046 84.6477 157.08 85.0612L161.237 142.743C161.255 142.943 161.23 143.145 161.163 143.335C161.097 143.525 160.991 143.699 160.851 143.844C160.712 143.99 160.544 144.104 160.357 144.179C160.17 144.254 159.969 144.288 159.768 144.279Z"
                          fill="white"
                        />
                        <path
                          d="M118.335 122.304L116.732 100.071L111.884 97.1523H98.5352L100.35 122.304H118.335Z"
                          fill="white"
                        />
                        <path
                          d="M118.334 122.536H100.348C100.289 122.537 100.231 122.515 100.187 122.475C100.143 122.435 100.117 122.379 100.113 122.32L98.3033 97.1676C98.301 97.136 98.3054 97.1043 98.3161 97.0745C98.3269 97.0448 98.3438 97.0176 98.3657 96.9948C98.3869 96.9711 98.4128 96.952 98.4417 96.9388C98.4706 96.9256 98.5019 96.9185 98.5337 96.918H111.883C111.925 96.9194 111.966 96.9309 112.003 96.9516L116.851 99.87C116.883 99.8887 116.911 99.9151 116.931 99.9468C116.951 99.9786 116.963 100.015 116.966 100.052L118.559 122.286C118.563 122.318 118.559 122.351 118.548 122.382C118.537 122.412 118.52 122.44 118.497 122.464C118.476 122.486 118.451 122.504 118.423 122.516C118.395 122.529 118.364 122.535 118.334 122.536ZM100.574 122.056H118.079L116.505 100.192L111.839 97.3836H98.7833L100.574 122.056Z"
                          fill="#393939"
                        />
                        <path
                          d="M116.731 100.071L111.883 97.1523L113.664 101.021L116.731 100.071Z"
                          fill="#EBEBEB"
                        />
                        <path
                          d="M113.664 101.252C113.62 101.252 113.577 101.239 113.539 101.216C113.502 101.192 113.472 101.158 113.453 101.118L111.672 97.2492C111.651 97.2037 111.645 97.1529 111.655 97.1039C111.664 97.0549 111.689 97.01 111.725 96.9756C111.763 96.943 111.81 96.9232 111.86 96.9189C111.91 96.9146 111.96 96.926 112.003 96.9516L116.851 99.87C116.89 99.8934 116.922 99.9276 116.942 99.9684C116.963 100.009 116.971 100.055 116.967 100.1C116.96 100.145 116.942 100.186 116.913 100.22C116.884 100.254 116.846 100.279 116.803 100.292L113.731 101.252H113.664ZM112.411 97.7388L113.789 100.739L116.189 100.004L112.411 97.7388Z"
                          fill="#393939"
                        />
                        <path
                          d="M106.08 108.481C106.087 108.612 106.068 108.742 106.023 108.865C105.978 108.987 105.908 109.099 105.818 109.194C105.728 109.289 105.62 109.365 105.5 109.416C105.38 109.468 105.251 109.494 105.12 109.494C104.846 109.489 104.584 109.383 104.383 109.196C104.183 109.009 104.059 108.754 104.035 108.481C104.023 108.349 104.039 108.216 104.082 108.091C104.125 107.966 104.194 107.851 104.285 107.755C104.376 107.659 104.486 107.583 104.609 107.533C104.731 107.482 104.863 107.459 104.995 107.463C105.27 107.47 105.532 107.577 105.733 107.765C105.933 107.952 106.057 108.208 106.08 108.481Z"
                          fill="#393939"
                        />
                        <path
                          d="M112.657 108.48C112.668 108.612 112.652 108.744 112.609 108.869C112.565 108.994 112.496 109.107 112.405 109.203C112.314 109.299 112.204 109.374 112.082 109.424C111.96 109.474 111.829 109.498 111.697 109.493C111.422 109.488 111.159 109.382 110.958 109.196C110.757 109.009 110.632 108.754 110.607 108.48C110.599 108.35 110.618 108.219 110.663 108.095C110.708 107.972 110.777 107.859 110.867 107.764C110.957 107.669 111.066 107.593 111.186 107.541C111.306 107.489 111.436 107.463 111.567 107.463C111.843 107.467 112.107 107.573 112.309 107.761C112.51 107.949 112.634 108.206 112.657 108.48Z"
                          fill="#393939"
                        />
                        <path
                          d="M114.519 115.076C114.46 115.075 114.404 115.052 114.362 115.012C114.319 114.972 114.293 114.918 114.288 114.86C114.168 113.223 111.605 111.893 108.576 111.893C106.565 111.893 104.76 112.493 103.867 113.453C103.684 113.63 103.54 113.844 103.446 114.081C103.352 114.318 103.309 114.572 103.32 114.826C103.322 114.858 103.318 114.889 103.308 114.919C103.298 114.949 103.282 114.977 103.262 115.001C103.22 115.049 103.161 115.078 103.097 115.083C103.033 115.087 102.971 115.066 102.922 115.025C102.874 114.983 102.845 114.923 102.84 114.86C102.826 114.542 102.878 114.224 102.994 113.927C103.11 113.63 103.286 113.361 103.512 113.137C104.472 112.085 106.426 111.428 108.562 111.428C111.888 111.428 114.6 112.921 114.735 114.826C114.737 114.856 114.732 114.887 114.723 114.915C114.713 114.944 114.698 114.971 114.677 114.993C114.657 115.016 114.633 115.035 114.606 115.048C114.578 115.061 114.549 115.069 114.519 115.071V115.076Z"
                          fill="#393939"
                        />
                        <path
                          d="M102.322 106.426C102.264 106.425 102.208 106.403 102.164 106.363C102.12 106.319 102.096 106.26 102.096 106.198C102.096 106.136 102.12 106.076 102.164 106.032L103.186 104.933C103.23 104.891 103.289 104.867 103.349 104.867C103.41 104.867 103.469 104.891 103.513 104.933C103.534 104.954 103.551 104.98 103.563 105.008C103.574 105.036 103.58 105.066 103.58 105.096C103.58 105.127 103.574 105.157 103.563 105.185C103.551 105.213 103.534 105.238 103.513 105.259L102.49 106.359C102.468 106.381 102.442 106.398 102.413 106.409C102.384 106.421 102.353 106.427 102.322 106.426Z"
                          fill="#393939"
                        />
                        <path
                          d="M114.037 106.426C113.979 106.423 113.923 106.401 113.879 106.363L112.703 105.264C112.681 105.243 112.663 105.217 112.651 105.189C112.639 105.16 112.633 105.13 112.633 105.099C112.633 105.068 112.639 105.037 112.651 105.009C112.663 104.98 112.681 104.955 112.703 104.933C112.747 104.891 112.805 104.867 112.866 104.867C112.927 104.867 112.986 104.891 113.029 104.933L114.205 106.032C114.227 106.054 114.244 106.079 114.256 106.107C114.267 106.135 114.273 106.165 114.273 106.195C114.273 106.226 114.267 106.256 114.256 106.284C114.244 106.312 114.227 106.337 114.205 106.359C114.16 106.401 114.1 106.425 114.037 106.426Z"
                          fill="#393939"
                        />
                        <path
                          d="M97.084 127.271H98.1688L99.7336 129.355L99.5848 127.271H100.679L100.948 131.035H99.8392L98.284 128.966L98.4328 131.035H97.3384L97.084 127.271Z"
                          fill="#393939"
                        />
                        <path
                          d="M101.439 129.153C101.402 128.898 101.419 128.637 101.491 128.389C101.562 128.141 101.685 127.91 101.852 127.713C102.034 127.534 102.252 127.395 102.492 127.307C102.732 127.218 102.988 127.182 103.244 127.2C103.784 127.17 104.316 127.351 104.727 127.704C105.103 128.079 105.321 128.584 105.336 129.115C105.376 129.481 105.327 129.852 105.192 130.195C105.068 130.471 104.86 130.701 104.597 130.853C104.282 131.022 103.927 131.103 103.57 131.088C103.203 131.099 102.837 131.031 102.5 130.886C102.204 130.744 101.954 130.521 101.78 130.243C101.574 129.915 101.456 129.54 101.439 129.153ZM102.605 129.153C102.601 129.448 102.695 129.735 102.874 129.969C102.949 130.052 103.041 130.117 103.144 130.16C103.247 130.203 103.358 130.223 103.469 130.219C103.576 130.226 103.682 130.208 103.78 130.165C103.878 130.123 103.964 130.057 104.031 129.974C104.169 129.712 104.214 129.411 104.16 129.12C104.162 128.837 104.068 128.563 103.892 128.342C103.815 128.261 103.721 128.197 103.618 128.155C103.515 128.113 103.403 128.093 103.292 128.097C103.187 128.093 103.083 128.113 102.988 128.156C102.893 128.2 102.809 128.265 102.744 128.347C102.604 128.594 102.555 128.883 102.605 129.163V129.153Z"
                          fill="#393939"
                        />
                        <path
                          d="M107.592 127.273H109.32C109.605 127.264 109.888 127.311 110.155 127.412C110.366 127.5 110.553 127.637 110.702 127.81C110.853 127.986 110.969 128.19 111.043 128.41C111.121 128.647 111.169 128.892 111.187 129.14C111.224 129.453 111.199 129.771 111.115 130.076C111.049 130.287 110.932 130.478 110.774 130.633C110.643 130.772 110.477 130.874 110.294 130.93C110.071 130.995 109.84 131.03 109.608 131.036H107.885L107.592 127.273ZM108.816 128.127L108.965 130.181H109.248C109.423 130.193 109.598 130.165 109.761 130.1C109.869 130.038 109.948 129.936 109.982 129.817C110.037 129.604 110.05 129.382 110.021 129.164C110.03 128.871 109.94 128.584 109.766 128.348C109.677 128.267 109.572 128.206 109.458 128.168C109.344 128.13 109.223 128.116 109.104 128.127H108.816Z"
                          fill="#393939"
                        />
                        <path
                          d="M113.977 130.411H112.657L112.518 131.035H111.332L112.474 127.271H113.761L115.446 131.035H114.226L113.977 130.411ZM113.674 129.599L113.166 128.246L112.849 129.599H113.674Z"
                          fill="#393939"
                        />
                        <path
                          d="M114.898 127.271H118.431L118.498 128.203H117.313L117.514 131.035H116.353L116.151 128.203H114.966L114.898 127.271Z"
                          fill="#393939"
                        />
                        <path
                          d="M121.137 130.411H119.817L119.678 131.035H118.492L119.635 127.271H120.902L122.582 131.035H121.367L121.137 130.411ZM120.835 129.599L120.321 128.246L119.999 129.599H120.835Z"
                          fill="#393939"
                        />
                      </svg>
                  </div>
                    <p style={{
                    fontFamily: "Source Sans 3",
                    fontSize: "20px",
                    fontWeight: 700,
                    fontStyle: "normal",
                    color:"#898989"
                  }}>
                    No templates are created til now
                  </p>
                </div>
              }
          </div>
          </div>
      )
  }

  const allTemplatesUi = () => {
      return(
          <div style={{ backgroundColor: "#FFF", borderRadius: "10px",}}>
          <Box
              sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "4px 16px",
                  borderBottomWidth: "1.2px",
              }}
              >
              <Button
                  disableRipple
                  disableElevation
                  sx={{
                  cursor: "default",
                  outline: "none !important",
                  borderBottom: "2px solid #1C485F",
                  borderRadius: 0,
                  color: "#1C485F",
                  textTransform: "none",
                  "&:hover": {
                      backgroundColor: "transparent",
                  },
                  }}
              >
                  <Typography
                  style={{
                      color: "#1C485F",
                      fontSize: "15px",
                      fontWeight: 700,
                      fontFamily: "Source Sans 3",
                  }}
                  component="h2"
                  >
                  All email templates
                  </Typography>
              </Button>
              {
                templateData[0].accordion[1].accordionServices.length === 0 && 
                <button
                onClick={()=>{
                  setEditableDataObj(null)
                  setOpenDrawer(true)}}
                style={{
                    fontSize: "12px",
                    borderRadius: "5px",
                    outline: "none",
                    border: "1.5px solid #1C485F",
                    color: "#1C485F",
                    padding: "8px 10px",
                }}
                >
                Create email template
            </button>
              }
          </Box>
          <div style={{padding:"14px"}}>
              <div style={{display:"flex",alignItems:"center",backgroundColor:"#FAFAFA",borderRadius:"10px"}}>
                  <div style={{width:"60%",padding:"10px 8px",color: "#393939",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontWeight: 700,
                fontStyle: "normal",}}>
                      Name
                  </div>
                  {/* <div style={{padding:"10px 6px",flexGrow:1,color: "#393939",
                fontFamily: "Source Sans 3",
                fontSize: "14px",
                fontWeight: 700,
                fontStyle: "normal",}}>
                      Type
                  </div> */}
              </div>
              {
                  data.map((data)=>(
                  <div key={data.id}  style={{display:"flex",alignItems:"center",backgroundColor:data.id % 2 !== 0 ?"#FFF":"#FAFAFA",borderRadius:"10px"}}>
                      <div style={{width:"60%",padding:"10px 8px"}}>
                          <p 
                          onClick={()=>{
                            setModalTitle(data.SubName)
                            setTemplateEmail(data.SubTemplate)
                            setOpenModal(true)
                          }}
                          style={{color: "#1C485F",
                          fontFamily: "Source Sans 3",
                          fontSize: "13px",
                          fontWeight: 400,
                          cursor: "pointer",
                          fontStyle: "normal"}}>{data.SubName}</p>
                      </div>
                      {/* <div style={{padding:"10px 6px",flexGrow:1}}>
                      <p 
                          style={{color: "#4B4B4B",
                          fontFamily: "Source Sans 3",
                          fontSize: "14px",
                          fontWeight: 400,
                          fontStyle: "normal"}}>{data.SubTemplate}</p>
                      </div> */}
                  </div>
                  ))
              }
          </div>
          </div>
      )
  }
  const handleCloseDrawer = (state) => {
    setOpenDrawer(false)
  }
  return (
    <div style={{ display: "flex", gap: "20px", alignItems: "flex-start",height:"100%"}}>
      <Helmet>
                    <title>Email Templates</title>
                    <meta name="description" content='Email campaign user all warmups' />
                </Helmet>
      <div style={{ width: "210px", backgroundColor: "#FFFFFF",height:"100%"}}>
        <p
          style={{
            color: "#393939",
            fontFamily: "Source Sans 3",
            fontSize: "14px",
            fontWeight: 700,
            fontStyle: "normal",
            padding: "10px 16px",
            backgroundColor: "#F3F3F3",
          }}
        >
          Templates
        </p>
        <PanelGroup accordion>
        {templateData.map((template) => (
            <div key={template.id}>
              <p
                style={{
                  color: "#868686",
                  fontFamily: "Source Sans 3",
                  fontSize: "14px",
                  fontWeight: 400,
                  fontStyle: "normal",
                  padding: "10px 16px",
                  backgroundColor: "#FAFAFA",
                }}
              >
                {template.title}
              </p>
              {template?.accordion?.map((val,idx)=>
              <Panel
              header={val.accordionTitle}
              eventKey={val._id}
              id={`panel${val._id}`}
            >
              {val.accordionServices?.map((service) => {
                console.log('vikkijabb',service)
                return(
                  <div
                  onClick={()=>{
                    if(idx===0){
                      setTempAdmin(true)
                      setData(service.Details)
                    }
                    else
                    {
                      setSelectedOption(service.Name)
                      setTempAdmin(false)
                    }
                    setSelectedFolder(service)
                    setSelectedTemplateArray(service.Details)
                    
                  }}
                  key={service._id}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent:"space-between",
                    padding: "9px 16px",
                    cursor: "pointer",
                    backgroundColor:selectedOption.length > 0 && selectedOption === service.Name ? "#FAFAFA" : "#FFF",
                  }}
                >
                  <div 
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="none"
                    >
                      <path
                        d="M17.5 7.70898V7.66732C17.5 6.7339 17.5 6.26719 17.3183 5.91067C17.1586 5.59707 16.9036 5.3421 16.59 5.18231C16.2335 5.00065 15.7668 5.00065 14.8333 5.00065L2.5 5.00065M2.5 5.00065L2.5 14.0007C2.5 14.9341 2.5 15.4008 2.68166 15.7573C2.84145 16.0709 3.09641 16.3259 3.41002 16.4857C3.76654 16.6673 4.23325 16.6673 5.16667 16.6673H5.83333M2.5 5.00065L2.5 4.66732C2.5 4.20061 2.5 3.96725 2.59083 3.78899C2.67072 3.63219 2.79821 3.50471 2.95501 3.42481C3.13327 3.33398 3.36663 3.33398 3.83334 3.33398H7.78105C7.98488 3.33398 8.08679 3.33398 8.1827 3.35701C8.26773 3.37742 8.34901 3.41109 8.42357 3.45678C8.50767 3.50832 8.57973 3.58038 8.72386 3.72451L10 5.00065M13.3333 11.6673L15 13.334M9.16667 17.5007V15.4173L15.4167 9.16732L17.5 11.2507L11.25 17.5007H9.16667Z"
                        stroke={`${selectedOption.length > 0 && selectedOption === service.Name ? "#1C485F" : "#868686"} `}
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </svg>
                    <p
                      style={{
                        color: selectedOption.length > 0 && selectedOption === service.Name ? "#1C485F" : "#393939",
                        fontFamily: "Source Sans 3",
                        fontSize: "14px",
                        fontWeight: 400,
                        fontStyle: "normal",
                        backgroundColor: "transparent",
                      }}
                    >
                      {service.Name}
                    </p>
                  </div>
                </div>
                )
              }
                
              )}
            </Panel>)}
              
            </div>
          ))}
        </PanelGroup>
      </div>
      {
        showLoader ? 
      <div style={{display:"flex",alignItems:"center",justifyContent:"center",padding:"50px",flexGrow: 1,height:"100%"}}>
        <CircularProgress sx={{ color: "#1C485F" }} />
      </div> 
      :
        <div style={{ flexGrow: 1 ,overflowY:"scroll",paddingTop:"6px"}}>
          
        {!tempAdmin ? optionsUi() : allTemplatesUi()}
      </div> 
      }
      {openModal && muiModal()}
      {openDrawer &&     
       <Modal
       open={openDrawer}
       onClose={handleCloseDrawer}
       aria-labelledby="modal-modal-title"
       aria-describedby="modal-modal-description"
     >
      <div
                className="modalPopup2"
               style={{height:"100vh",width:'90vw'}}
              >
      <DrawerClass data={openDrawer} closeFun={handleCloseDrawer} getAllUserTemplate={getAllTemplate} selectedFolder={selectedFolder} editableDataObj={editableDataObj} setSelectedOption={setSelectedOption} />
      </div>
      </Modal>
      }
      {openDeleteModal && deleteModal()}
      {openDeleteFolderModal && deleteFolderModal()}
      {showToast && <ToastContainer />}
      {open&&(
        <Modal
        open={open}
        onClose={() => {
          setOpen(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <div className="modalPopupDelete">
          <div className="modaltext">Fallback</div>
          <div className="modalsubtext">
          Add fallback text for variable <span style={{color:'black',fontWeight:'bolder'}}>{selectedVar}</span> if we can't find this data in the leads profile
          </div>
          <TextField
          autoComplete="off"
                value={fallBackText}
                onChange={(e) => {
                  setFallBackText(e.target.value);
                }}
                variant="standard"
                placeholder="Enter fallback text"
                InputProps={{
                  disableUnderline: true,

                  sx: {
                    display: "flex",
                    padding: "10px 16px",
                    alignItems: "center",
                    gap: "10px",
                    borderRadius: "4px",
                    border:'1px solid #1C485F',
                    background: "var(--background-color, #FAFAFA)",
                    width:'26vw',
                    "& input": {
                      color: "#868686",
                      fontFamily: "Source Sans 3",
                      fontSize: "14px",
                      fontStyle: "normal",
                      fontWeight: 400,
                      lineHeight: "20px",
                    },
                  },
                }}
              />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: "10px",
              width: "100%",
            }}
          >
            <div
              className="cancelbuttonmodal"
              onClick={() => {
                setOpen(false);
              }}
            >
              Cancel
            </div>
            <div
              className="continuebuttonmodal"
              // onClick={() => {
              //   deleteScheduleById();
              // }}
            >
              Save
            </div>
          </div>
        </div>
      </Modal>
      )}
      
    </div>
  );
};

export default TemplatesComponent;
